import { Col, EventHandler, InputField, Label, OutlineButton, Row } from "client/CommonComponents";
import close from "../../../../assets/images/Close_SuccessPopup.svg";
import './DriverTitle.scss'

const DriverTitle = (props: any) => {
    
    const error = props.error;
    return (
        <div className="tooltip-container driver-details">

            <div className='content'>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} className='mb-md-0 mb-2'>
                    
                        <div className="driver-container"> 
                            <div>
                                <Label data-attribute="DriverTitle_Default_Label">Drivers</Label>
                            </div>
                            <div className='header'>
                                <EventHandler onEvent={(e: any) => props.onDriverCloseLinkAttachment(e)} data-attribute="DriverTitle_Default_EventHandler">
                                    <img src={close} alt="" />
                                </EventHandler>
                            </div>
                        </div>

                        <div className='drivers-section'>
                            <InputField
                                className={error.maxLengthError?.length > 0 ? "comments me-3 controlValidation" : "comments me-3"}
                                value={props.name}
                                onChange={props.onChange}
                             data-attribute="DriverTitle_Default_Input" />
                            <OutlineButton
                                text="Add Driver"
                                className="save-btn me-0"
                                onClick={props.onAdd}
                                disabled={(error?.maxLengthError?.length > 0 || error?.driverCountError?.length > 0 || props.name?.trim() === "") ? true : false}
                             data-attribute="DriverTitle_Default_Button" />
                        </div>
                        {error?.maxLengthError?.length > 0 ? <p><span className="required">{error?.maxLengthError}</span></p> : ""}
                        {error?.driverCountError?.length > 0 ? <span className="required">{error?.driverCountError}</span> : ""}
                        <ul className='drivers-ul-list'>
                            {props.list.map((item: any, index: any) => (
                                <li
                                    key={index}
                                    className={"todo-list__list-item"}
                                >
                                    <span className="item" title={item.employeeFullName}>{item.employeeFullName}</span>
                                    <EventHandler onEvent={() => props.removeDrivername(index)} data-attribute={`DriverTitle_${(item?.employeeFullName || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                                        <img src={close} alt='close' className='removedriver' />
                                    </EventHandler>
                                </li>
                            ))}
                        </ul>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default DriverTitle;